export const FORMATS = {
    luxon: {
        date: "yyyy-MM-dd",
        time: "HH:mm",
        datetime: "yyyy-MM-dd HH:mm",
    },
    moment: {
        date: "YYYY-MM-DD",
        time: "HH:mm",
        date_friendly: "Do MMM YYYY",
        datetime: "YYYY-MM-DD HH:mm",
        time_second: "HH:mm:ss",
        localized: {
            time: "LT",
            date_short: "L",
            datetime: "L LT",
        },
    },
};
//# sourceMappingURL=formats.js.map